import { WarehouseTypes } from '@@/warehouses/ts';
import {
  WarehouseSleeveIcon,
  WarehouseStationaryIcon,
} from '@@/warehouses/icons/types.icons';

export const WAREHOUSES_TYPES_ICON_DICTIONARY = {
  [WarehouseTypes.Sleeve]: WarehouseSleeveIcon,
  [WarehouseTypes.Stationary]: WarehouseStationaryIcon,
};
